import { appState } from '$mapapp/stores/appstate.svelte'
import { RADIUS_MAX_KM, RADIUS_MIN_KM } from '$mapapp/stores/matching-config'
import { syncRadiusParam } from '$mapapp/stores/url.svelte'

export function isValidMatchingRadius(radius: number | undefined): radius is number {
	return typeof radius === 'number' && Number.isFinite(radius) && radius >= RADIUS_MIN_KM && radius <= RADIUS_MAX_KM
}

/**
 * Validate and commit a matching radius (`to` bound in km).
 *
 * Rejects values that fail {@link isValidMatchingRadius}. On success writes
 * `appState.matching.radius.to`, refetches matches, and syncs the URL
 * `radius` param.
 *
 * @returns `true` when the radius was accepted and applied
 */
export function validateAndSaveRadius(radius: number | undefined): boolean {
	if (!isValidMatchingRadius(radius)) return false

	const matching = appState.matching
	if (!matching) return false

	matching.radius.to = radius
	matching.refetch()
	syncRadiusParam(radius)
	return true
}
